import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Backend } from '../../_models/backend';
import { NgSelectConfig } from '@ng-select/ng-select';
import LanguageType = Backend.LanguageType;

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  currentLanguage: LanguageType = 'EN'; // default

  languages: LanguageType[] = [ 'EN' , 'DE', 'FR', 'ES', 'HU', 'SK', 'ZH' ]; // TODO add langs
  languageLabels: Map<string, string> = new Map<string, string>([
    ['EN', 'English'],
    ['DE', 'Deutsch'], // TODO add langs
    ['FR', 'Français'],
    ['ES', 'Español'],
    ['HU', 'Magyar'],
    ['SK', 'Slovenský'],
    ['ZH', '中文']
  ]);

  constructor(private translate: TranslateService, private selectConfig: NgSelectConfig) {
  }

  getLanguage(languageType: LanguageType | undefined | null): LanguageType {
    if (languageType != null && this.languages.includes(languageType)) {
      return languageType;
    }

    const browserLang = this.translate.getBrowserLang();
    if (browserLang === 'hu') {
      return 'HU';
    } else if (browserLang === 'de') { // TODO add langs
      return 'DE';
    } else if (browserLang === 'fr') {
      return 'FR';
    } else if (browserLang === 'zh') {
      return 'ZH';
    } else if (browserLang === 'es') {
      return 'ES';
    } else if (browserLang === 'sk') {
      return 'SK';
    }

    return 'EN';
  }

  changeLanguage(languageType: LanguageType | undefined | null): void {
    const lang = this.getLanguage(languageType);
    this.useLanguage(lang);
  }

  useLanguage(languageType: LanguageType): void {
    this.currentLanguage = languageType;

    const lang = languageType.toLowerCase();
    this.translate.use(lang).subscribe(() => {
      this.selectConfig.notFoundText = this.translate.instant('COMMON.NO_ITEMS_FOUND');
    });
  }

}
